import { ViewEncapsulation } from '@angular/compiler';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ClaimItem } from 'src/app/model/claim-item';
import { ClientItem } from 'src/app/model/client-item';
import { DeviceItem } from 'src/app/model/device-item';
import { RegisteredDeviceItem, RegisteredItemInfo } from 'src/app/model/policy-detail-item';
import { AnswerOption2 } from 'src/app/model/question-item';
import { QuestionSetItem } from 'src/app/model/questionset-item';
import { RegisterDevice } from 'src/app/model/register-device';
import { CommonService } from 'src/app/services/common.service';
import { ExternalService } from 'src/app/services/external.service';
import { MSSPService } from 'src/app/services/mssp.service';
import { StorageService } from 'src/app/services/storage.service';


@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss']
})
export class PersonalComponent implements OnInit {

  @Output() personalForm:EventEmitter<FormGroup> = new EventEmitter();
  @Output() personalStepBack:EventEmitter<boolean> = new EventEmitter();
  @Output() questionSetItem:EventEmitter<QuestionSetItem> = new EventEmitter();

  clientItems!: ClientItem[];
  question!:QuestionSetItem
  serialNumber: string = '';

  constructor(
    private fb: FormBuilder,
    public commonService:CommonService,
    private mssService:MSSPService,
    private route: ActivatedRoute
  ) {
    this.serialNumber = route.snapshot.params['deviceId'];
  }

  formGroup: FormGroup = this.fb.group({
    owner:['', Validators.required],
    name: ['', Validators.required],
    lastName: ['', Validators.required],
    secondLastName: ['', Validators.required],
    email: ['', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
    phone: ['', Validators.required]
  });

  stepBack(){
    this.personalStepBack.emit(true)
  }

  stepOn() {
    if (this.formGroup.valid) {
      var owner = this.formGroup.get('owner')
      var name = this.formGroup.get('name')
      var lasName = this.formGroup.get('lastName')
      var secondLastName = this.formGroup.get('secondLastName')
      var email = this.formGroup.get('email')
      var phone = this.formGroup.get('phone')
      if (owner && name && lasName && secondLastName && email && phone) {
        this.commonService.phone = phone?.value
        this.commonService.personalForm = this.formGroup
        this.commonService.getPolicyDetails(this.commonService.policy, this.commonService.idCliente, this.commonService.certificate,  this.commonService.deviceId)
          .subscribe(({reqMssp}) => {
            const product = this.commonService.reqClientData.RequestIntegration.find(r => r.SRNumber === this.serialNumber)
            let R3FecServ = (typeof product !== 'undefined') ? product.R3Fechaservicio : '';
            var claimItem = new ClaimItem(
              this.commonService.idCliente,
              reqMssp.data.CertificateNumber,
              phone?.value,
              name?.value,
              lasName?.value +" "+ secondLastName?.value,
              "SELF",
              "CP",
              email?.value,
              "es-MX",
              owner?.value,
              "",
              "REPCLM",
              reqMssp.data.DealerCode,
              R3FecServ,
              this.commonService.companyCode,
              this.commonService.policy
            )
            const registeredDevices = reqMssp.data.DealerCode === 'EA113' ? reqMssp.data.ItemInfo : reqMssp.data.ItemInfo[0].RegisteredDevices;
              var device = this.findDevice(registeredDevices,this.commonService.deviceId)
              if(device){
                this.commonService.getBuildClaim(claimItem).subscribe(({reqDevice}) => {
                  if(device && reqDevice.data){

                    let registeredDevice: RegisteredItemInfo | undefined;
                    if (Array.isArray(reqDevice.data.RegisteredItems)) {
                      const registeredItems = reqDevice.data.RegisteredItems as Array<RegisteredItemInfo>
                      
                      registeredDevice = registeredItems.find(x => x.RegisteredItemName === device?.RegisteredDeviceName);
                    }
                    this.commonService.caseNumber = reqDevice.data.CaseNumber,
                    this.commonService.interactionNumber = reqDevice.data.InteractionNumber

                    if (typeof registeredDevice !== 'undefined') {
                        var deviceSelectionItem = new DeviceItem(
                        this.commonService.idCliente,
                        registeredDevice.Manufacturer,//reqDevice.data.RegisteredItems[0].Manufacturer, //device.Make,
                        registeredDevice.Model,
                        registeredDevice.SerialNumber, //reqDevice.data.RegisteredItems[0].SerialNumber, //device.SerialNumber,
                        registeredDevice.RegisteredItemName, //reqDevice.data.RegisteredItems[0].RegisteredItemName, // device.RegisteredDeviceName
                        registeredDevice.PurchasePrice.toString(), //reqDevice.data.RegisteredItems[0].PurchasePrice, // device.DevicePurChasePrice
                        registeredDevice.PurchasedDate, // reqDevice.data.RegisteredItems[0].PurchasedDate, // device.DevicePurchaseDate
                        registeredDevice.DeviceType,//reqDevice.data.RegisteredItems[0].DeviceType, // device.DeviceType
                        registeredDevice.ExpirationDate,//reqDevice.data.RegisteredItems[0].ExpirationDate, // device.ExpirationDate
                        registeredDevice.RiskTypeCode,//reqDevice.data.RegisteredItems[0].RiskTypeCode, // this.commonService.risk,
                        reqDevice.data.CaseNumber,
                        reqDevice.data.InteractionNumber,
                        this.commonService.dealerCode,
                        this.commonService.companyCode
                      )
                      this.mssService.deviceSelection(deviceSelectionItem).subscribe((res) => {
                        if(res){
                          this.question = res.data
                          this.commonService.questionSetItem = res.data
                          this.question.Questions.forEach((question, index) => {
                            if (Number(question.AnswerType) === 3) {
                              let answer = question.Answer as AnswerOption2
                              if (answer.Answers[0].Text === 'Sí') {
                                answer.Answers[0].Text = 'Yes';
                              }
                            }
                          });
                          this.questionSetItem.emit(this.question);
                          this.personalForm.emit(this.formGroup);
                        }
                      })
                    }
                  }
                })

              }
              else
              {
                console.log("error", "no tiene productos en dispositivos registrados")
              }
          })
      }



    }
  }
  
  findDevice(registerDevices:RegisterDevice[], serialNumber:string):RegisterDevice | null{
    if(registerDevices.length > 0){
      var registerDev = registerDevices.find(res => res.SerialNumber === serialNumber || res.RegisteredDeviceName === serialNumber || res.RegisteredItemIdentifier === serialNumber)
      if(registerDev) return registerDev
    }
    return null
  }

  ngOnInit(): void {
  }

  setPersonalData(clean:boolean){
    if(!clean){
      this.formGroup.controls['name'].setValue(this.commonService.firstName)
      this.formGroup.controls['lastName'].setValue(this.commonService.lastName)
      this.formGroup.controls['secondLastName'].setValue(this.commonService.secondLastName)
      return
    }
    this.formGroup.controls['name'].setValue('')
    this.formGroup.controls['lastName'].setValue('')
    this.formGroup.controls['secondLastName'].setValue('')

  }

  toLowerCase(event:any){
    var email = this.formGroup.get('email')
    email?.value + event.target.value.toLowerCase
    this.formGroup.controls['email'].setValue(email?.value.toLowerCase())

  }

}
